import * as React from 'react';

export const YandexMetrika = () => {
  return (
    <>
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html:
            '        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n' +
            '        m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n' +
            '        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");\n' +
            '\n' +
            '        ym(56386537, "init", {\n' +
            '        clickmap:true,\n' +
            '        trackLinks:true,\n' +
            '        accurateTrackBounce:true,\n' +
            '        webvisor:true,\n' +
            '        ecommerce:"dataLayer"\n' +
            '      });',
        }}
      ></script>
      <noscript>
        <div>
          <img src="https://mc.yandex.ru/watch/56386537" style={{ position: 'absolute', left: '-9999px' }} alt="" />
        </div>
      </noscript>
    </>
  );
};
